VGTierApp.CartPage.Show_CalculateTier = function () {

    var variantsMFArray = commonFields_CD.variantsMFArray;
    var currencySymbol = globalFields.currencySymbol;
    var isCartPage = globalFields.isCartPage;
  	var isProductPage = globalFields.isProductPage;
    var cartItemsCart = commonFields_CD.cartItemsCart;
    var variantIdsToSend = [];
    var minimumDiscountSubtotal = 0;
    var priceDiff = 0;

    var TieredPricingCart = function (cartItems, isUpdate, isCartPage) {
        variantIdsToSend = [];
        minimumDiscountSubtotal = 0;
        priceDiff = 0;
        var updatedCartSubTotal = 0.00;
        var originalCartSubTotal = 0;
        var quantityAlreadyAdded = [];

        var index = 0;
        for (k = 0; k < cartItems.length; k++) {
            var item = cartItems[k];
            var variantId = item.variantId;
            var cartItemQty = Number(item.itemQty);
            var originalItemPrice = item.originalItemPrice;
            var originalLineItemSubtotal = cartItemQty * originalItemPrice;
            originalCartSubTotal += originalLineItemSubtotal;

            if (item.tierPricing != "") {
                var tierPricing_ = item.tierPricing;
                var splitTierPricing_ = tierPricing_.split(',');
                if (!(splitTierPricing_[5] === 'true') && !globalFields.StartEndDateValid(splitTierPricing_)) {
                    item.tierPricing = "";
                }
            }

            if (item.tierPricing != "") {
                variantIdsToSend.push(variantId);
                minimumDiscountSubtotal += originalLineItemSubtotal;
                var isNotInRange = true;
                var tierPricing = item.tierPricing;
                var updatedTiersubTotal = 0.0;
                var splitTierPricing = tierPricing.split(',');
                var originalItemPrice = 0;
                if (splitTierPricing[1].split('-')[0] === 'collection') {
                    var rslt = CalculateTierCollection(splitTierPricing, updatedTiersubTotal, updatedCartSubTotal, isUpdate, isCartPage, isNotInRange, cartItemQty, item.originalItemPrice, index, cartItems, quantityAlreadyAdded);
                    quantityAlreadyAdded = rslt[2];
                }
                else {
                    var rslt = CalculateTier(splitTierPricing, updatedTiersubTotal, updatedCartSubTotal, isUpdate, isCartPage, isNotInRange, cartItemQty, item.originalItemPrice, index, cartItems, quantityAlreadyAdded);
                }
                updatedCartSubTotal = rslt[0];
                if (rslt[1]) {
                    updatedCartSubTotal = CalculateSubtotal(item.originalItemPrice, cartItemQty, updatedCartSubTotal);
                }
            }
            else {
                updatedCartSubTotal = CalculateSubtotal(item.originalItemPrice, cartItemQty, updatedCartSubTotal);
            }
            index++;
        }
        UpdateCartSubtotal(isUpdate, isCartPage, updatedCartSubTotal, originalCartSubTotal);
        priceDiff = originalCartSubTotal - updatedCartSubTotal;
        if (priceDiff > 0 && isUpdate && isCartPage) {
          	var saveText = "You're saving";
            if (jQuery('#saved-banner-div').length == 0) {
                jQuery('form.cart').before('<div id="saved-banner-div" class="col-md-12"><h3 id="saved-banner">' + saveText + ' <span class="money" data-currency-usd="' + currencySymbol + priceDiff.toFixed(2) + '">' + currencySymbol + priceDiff.toFixed(2) + '</span></h3></div>');
            }
            else {
                jQuery('#saved-banner-div').html('<h3 id="saved-banner">' + saveText + ' <span class="money" data-currency-usd="' + currencySymbol + priceDiff.toFixed(2) + '">' + currencySymbol + priceDiff.toFixed(2) + '</span></h3>');
            }
        }
        else if (isCartPage) {
            jQuery('#saved-banner-div').remove();
        }
        priceDiff = priceDiff.toFixed(2);
        priceDiff = Number(priceDiff);
        cartItemsCart = cartItems;
    }

    var CalculateTierCollection = function (splitTierPricing, updatedTiersubTotal, updatedCartSubTotal, isUpdate, isCartPage, isNotInRange, cartItemQty, originalItemPrice, index, cartItems, quantityAlreadyAdded) {
        for (i = 6; i < splitTierPricing.length; i++) {
            var createdOnId = splitTierPricing[1].split('-')[1];
            var allVariantItemQty = 0;
            var tierRange = splitTierPricing[i].split('=')[0];
            var tierPrice = splitTierPricing[i].split('=')[1];
            var minTier = parseInt(tierRange.split("-")[0]);
            var maxTier = parseInt(tierRange.split("-")[1]);
            var maxTier = tierRange.split("-")[1];
            if (maxTier != "max") {
                maxTier = parseInt(tierRange.split("-")[1]);
            }
            var updatedTierPrice = 0;

            var condition1 = false; var condition2 = false; var condition3 = false;
            var arr = jQuery.grep(cartItems, function (n) { return (n.collectionId === createdOnId); });
            for (j = 0; j < arr.length; j++) {
                allVariantItemQty += arr[j].itemQty;
            }
            var isInThisRange = true;
            for (m = i; m < splitTierPricing.length; m++) {
                if (m > i || i == splitTierPricing.length - 1) {
                    var minTier2 = parseInt(splitTierPricing[m].split('=')[0].split("-")[0]);
                    if ((allVariantItemQty >= minTier2) && i != splitTierPricing.length - 1) {
                        isInThisRange = false;
                        //break;
                    }
                }
            }

            if (allVariantItemQty >= minTier) {
                condition1 = true;
            }
            if (maxTier == "max" || i == splitTierPricing.length - 1) {
                condition2 = true;
            }
            else if (allVariantItemQty >= maxTier) {
                condition2 = true;
            }

            if (isInThisRange) {
                var arr = jQuery.grep(quantityAlreadyAdded, function (n) { return (n.productId === createdOnId); });
                if (arr.length != 0) {
                    var isDone = arr[0].isDone;
                    if (!isDone) {
                        condition3 = true;
                    }
                }
                else {
                    quantityAlreadyAdded.push({ productId: createdOnId, qtyAdded: 0, minQty: minTier, maxQty: maxTier, isDone: false });
                    condition3 = true;
                }
            }
            var originalItemPrice2 = originalItemPrice;
            if (condition1 && condition2 && condition3 && isInThisRange) {
                isNotInRange = false;
                var arr2 = jQuery.grep(quantityAlreadyAdded, function (n) { return (n.productId === createdOnId); });
                for (var k = 1; k <= cartItemQty; k++) {
                    originalItemPrice = originalItemPrice2;
                    if (!arr2[0].isDone) {
                        if (splitTierPricing[0].trim() == "fixed") {
                            updatedTierPrice = originalItemPrice - parseFloat(tierPrice);
                            updatedTierPrice = updatedTierPrice.toFixed(2);
                            updatedTierPrice = Number(updatedTierPrice);
                        }
                        if (splitTierPricing[0].trim() == "percentage") {
                            var p = parseFloat(tierPrice) / 100;
                            var originalPriceCut = parseFloat(p * originalItemPrice);
                            originalPriceCut = originalPriceCut.toFixed(2);
                            originalPriceCut = Number(originalPriceCut);
                            originalItemPrice = originalItemPrice - originalPriceCut;
                            originalItemPrice = originalItemPrice.toFixed(2);
                            originalItemPrice = Number(originalItemPrice);
                            updatedTierPrice = parseFloat(originalItemPrice);
                        }
                        if (updatedTierPrice < 0) {
                            updatedTierPrice = 0;
                        }

                        quantityAlreadyAdded = UpdateArrayObject(createdOnId, 1, quantityAlreadyAdded);
                    }
                    else {
                        updatedTierPrice = originalItemPrice;
                        quantityAlreadyAdded = UpdateArrayObject(createdOnId, 1, quantityAlreadyAdded);
                    }

                    updatedTiersubTotal = updatedTierPrice * 1;
                    updatedTiersubTotal = updatedTiersubTotal.toFixed(2);
                    updatedCartSubTotal += Number(updatedTiersubTotal);
                    updatedCartSubTotal = updatedCartSubTotal.toFixed(2);
                    updatedCartSubTotal = Number(updatedCartSubTotal);
                }
            }
            if (isInThisRange) {
                break;
            }

        }

        return [updatedCartSubTotal, isNotInRange, quantityAlreadyAdded];
    }

    function UpdateArrayObject(pId, newQty, quantityAlreadyAdded) {
        for (var i = 0; i <= quantityAlreadyAdded.length; i++) {
            if (quantityAlreadyAdded[i].productId == pId) {
                quantityAlreadyAdded[i].qtyAdded += newQty;
                if (quantityAlreadyAdded[i].qtyAdded == quantityAlreadyAdded[i].maxQty) {
                    quantityAlreadyAdded[i].isDone = true;
                }
                break;
            }
        }
        return quantityAlreadyAdded;
    }

    var CalculateTier = function (splitTierPricing, updatedTiersubTotal, updatedCartSubTotal, isUpdate, isCartPage, isNotInRange, cartItemQty, originalItemPrice, index) {
        for (i = 6; i < splitTierPricing.length; i++) {
            var tierRange = splitTierPricing[i].split('=')[0];
            var tierPrice = splitTierPricing[i].split('=')[1];
            var minTier = parseInt(tierRange.split("-")[0]);
            var maxTier = parseInt(tierRange.split("-")[1]);
            var maxTier = tierRange.split("-")[1];
            var updatedTierPrice = 0;
            if (maxTier != "max") {
                maxTier = parseInt(tierRange.split("-")[1]);
            }
            var condition1 = false; var condition2 = false;
            if (cartItemQty >= minTier) {
                condition1 = true;
            }
            else if (cartItemQty <= maxTier) {
                condition2 = true;
            }
            if (condition1 && condition2) {
                isNotInRange = false;

                if (splitTierPricing[0].trim() == "fixed") {
                    updatedTierPrice = originalItemPrice - parseFloat(tierPrice);
                    updatedTierPrice = updatedTierPrice.toFixed(2);
                    updatedTierPrice = Number(updatedTierPrice);
                }

                if (splitTierPricing[0].trim() == "fixed_price") {
                    updatedTierPrice = parseFloat(tierPrice);
                    updatedTierPrice = updatedTierPrice.toFixed(2);
                    updatedTierPrice = Number(updatedTierPrice);
                }

                if (splitTierPricing[0].trim() == "percentage") {
                    var p = parseFloat(tierPrice) / 100;
                    var originalPriceCut = parseFloat(p * originalItemPrice);
                    originalPriceCut = originalPriceCut.toFixed(2);
                    originalPriceCut = Number(originalPriceCut);
                    originalItemPrice = originalItemPrice - originalPriceCut;
                    originalItemPrice = originalItemPrice.toFixed(2);
                    originalItemPrice = Number(originalItemPrice);
                    updatedTierPrice = parseFloat(originalItemPrice);
                }
                if (updatedTierPrice < 0) {
                    updatedTierPrice = 0;
                }
                updatedTiersubTotal = updatedTierPrice * cartItemQty;
                updatedTiersubTotal = updatedTiersubTotal.toFixed(2);
                updatedCartSubTotal += Number(updatedTiersubTotal);
                updatedCartSubTotal = updatedCartSubTotal.toFixed(2);
                updatedCartSubTotal = Number(updatedCartSubTotal);
                updatedTierPrice = updatedTierPrice.toFixed(2);
                //UpdateCartItem(isUpdate, isCartPage, updatedTierPrice, updatedTiersubTotal, index);
            }
        }

        return [updatedCartSubTotal, isNotInRange];
    }

    var CalculateSubtotal = function (formattedPrice, cartItemQty, updatedCartSubTotal) {
        formattedPrice = formattedPrice.toFixed(2);
        formattedPrice = Number(formattedPrice);
        formattedPrice = formattedPrice * cartItemQty;
        updatedCartSubTotal += formattedPrice;
        updatedCartSubTotal = updatedCartSubTotal.toFixed(2);
        updatedCartSubTotal = Number(updatedCartSubTotal);
        return updatedCartSubTotal;
    }

    var UpdateCartItem = function (isUpdate, isCartPage, updatedTierPrice, updatedTiersubTotal, index) {
        if (isUpdate) {
            //jQuery('[data-label="Price"]').eq(index).text(currencySymbol + updatedTierPrice);
            //jQuery('[data-label="Total"]').eq(index).text(currencySymbol + updatedTiersubTotal);
        }
    }

    var UpdateCartSubtotal = function (isUpdate, isCartPage, updatedCartSubTotal, originalCartSubTotal) {
        var total_row = jQuery('.total-row--sub-total .total-row__value'),
            cart_total = jQuery('#cartform #cart-total-amount');

        if (isUpdate) {
            if (originalCartSubTotal != updatedCartSubTotal) {
                //console.log(jQuery('span.vg-mini-cart-subtotal').length)
                total_row.html(currencySymbol + updatedCartSubTotal.toFixed(2));
              	
                if (!total_row.next('.vg-strike-through').length) {
                    total_row.after('<span class="vg-strike-through money">' + ' ' + currencySymbol + originalCartSubTotal.toFixed(2) + '</span>');
                }

                cart_total.html(currencySymbol + updatedCartSubTotal.toFixed(2));
                
                if (!cart_total.next('.vg-strike-through').length) {
                    cart_total.after('<span class="vg-strike-through money">' + ' ' + currencySymbol + originalCartSubTotal.toFixed(2) + '</span>');
                }

            }
            else {
                total_row.html(currencySymbol + updatedCartSubTotal.toFixed(2)).next('.vg-strike-through').remove();
                cart_total.html(currencySymbol + updatedCartSubTotal.toFixed(2)).next('.vg-strike-through').remove();
            }

        }
    }

    var CheckoutClickCart = function () {
        $('input[name="checkout"], #checkout').click(function () {
            $('[name="updates[]"]').each(function () {
                var qtyValue = this.value;
                var idAtrbtValue = $(this).attr('id');
                idAtrbtValue = idAtrbtValue.split('_');
                idAtrbtValue = idAtrbtValue[1];
                idAtrbtValue = idAtrbtValue.split(':');
                idAtrbtValue = idAtrbtValue[0];

                for (i = 0; i < cartItemsCart.length; i++) {
                    if (cartItemsCart[i].variantId == idAtrbtValue) {
                        cartItemsCart[i].itemQty = Number(qtyValue);
                    }
                }
            });

            TieredPricingCart(cartItemsCart, false, isCartPage);
            GetCode();
        });
    }

    var CheckoutClickAjax = function () {
        $('form.ajaxcart button[name="checkout"], #checkout').click(function () {
            GetCode();
        });
    }

    var GetCode = function () {
        if (priceDiff > 0) {
            $.ajax({
                type: "POST",
                async: false,
                url: "https://www.vgroupapps.com/TieredPricing/api/services/GetCode",
                data: {
                    priceDifference: priceDiff,
                    subTotal: minimumDiscountSubtotal,
                    variantIds: variantIdsToSend.toString()
                },
                success: function (result) {
                    var data_ = JSON.stringify(result);
                    var parsed_data = JSON.parse(data_);
                    var PRID = parsed_data.PRID;
                    var DCID = parsed_data.DCID;
                    var DiscountCode = parsed_data.DiscountCode;
                    SetCookie("discountCodes", PRID + "-" + DCID + "-" + DiscountCode, 30);
                  	DiscountCodeCookie(DiscountCode);
                    $('form.cart').append('<input id="discount_input" type="hidden" name="discount" value="' + DiscountCode + '">');
                },
                error: function (e) {console.log(e.statusText);}
            });
        }
    }
    
    var DiscountCodeCookie = function (discount_code) {
        $.ajax({
            type: "HEAD", url: "/discount/" + discount_code,
            success: function (_result) { },
            error: function (e) { console.log(e.statusText); }
        })
    }

    var FetchMetafield = function (productHandle, variant_id) {
        var variantMF = "";
        var isExist = commonFields_CD.variantsMFArray[variant_id];
        if (isExist != undefined) {
            variantMF = commonFields_CD.variantsMFArray[variant_id];
        }
        else if (isExist == undefined && isProductPage) {
            variantMF = commonFields_PD.variantsMFArray_PD[variant_id];
        }
        if (variantMF == "" || variantMF == undefined) {
            $.ajax({
                async: false,
                url: "/products/" + productHandle + "?view=vgmetafields",
                success: function (result) {
                    var data_ = JSON.parse(result);
                    for (var k = 0; k < data_.length; k++) {
                        var variantMetafieldChoosen = data_[k];
                        if (variantMetafieldChoosen.variantId === variant_id) {
                            var tiers = variantMetafieldChoosen.tiers['tieredpricing'];
                            if (tiers != "" && tiers != undefined) {
                                variantMF = tiers;
                            }
                        }
                    }
                },
                error: function (e) {
                    console.log(e.statusText);
                }
            });
        }
        return variantMF;
    }

    function InvokeDetectAjax() {
        $(document).ajaxComplete(function (event, xhr, settings) {
            var splittedUrl = settings.url
            if (splittedUrl != 'undefined' && splittedUrl != "" && splittedUrl != null) {
                splittedUrl = splittedUrl.split("?");
                if (splittedUrl[0] === "/cart.js" || splittedUrl[0] === "/cart/change.js") {
                    var response = JSON.parse(xhr.responseText);
                    setTimeout(function () {
                        cartItemsCart = [];
                        for (var i = 0; i < response.items.length; i++) {
                            var item = response.items[i];
                            var originalPrice = item.original_price / 100;
                            originalPrice = originalPrice.toFixed(2);
                            originalPrice = Number(originalPrice);
                            var collectionId = 0;
                            var tiers = FetchMetafield(item.handle, item.variant_id);
                            if (tiers != "" && tiers.split(',')[1].split('-')[0] === 'collection') {
                                collectionId = tiers.split(',')[1].split('-')[1];
                            }
                          	//commonFields_CD.variantsMFArray[item.variant_id] = tiers;
                            var item1 = { variantId: item.variant_id, tierPricing: tiers, originalItemPrice: originalPrice, itemQty: item.quantity, productId: (item.product_id).toString(), collectionId: collectionId };
                            cartItemsCart.push(item1);
                        }
                        TieredPricingCart(cartItemsCart, true, isCartPage); CheckoutClickAjax();
                    }, 100);
                }
              	else if (splittedUrl[0] == "/cart") {
                    setTimeout(function () {
                        TieredPricingCart(cartItemsCart, true, isCartPage); CheckoutClickAjax(); CheckoutClickCart();
                    }, 500);
                }
            }
        });
    }
console.log(cartItemsCart)
    function SetCookie(cname, cvalue, exdays) { var d = new Date(); d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000)); var expires = "expires=" + d.toUTCString(); document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/"; }

    InvokeDetectAjax();
    TieredPricingCart(cartItemsCart, true, isCartPage); CheckoutClickCart();
    setTimeout(function () { TieredPricingCart(cartItemsCart, true, isCartPage); }, 500);
}
var commonFields_CD = new VGTierApp.CartPage.Global(); var cartObject = new VGTierApp.CartPage.Show_CalculateTier();